module.exports = __webpack_public_path__ + "static/img/b1.f258b5c8.png";